import firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/firestore';

var config = {
  apiKey: "AIzaSyADVrQh-ZMsAtSRGU1Wz86f_fsTdhaHgyo",
  authDomain: "namecard-7e782.firebaseapp.com",
  databaseURL: "https://namecard-7e782.firebaseio.com",
  projectId: "namecard-7e782",
  storageBucket: "namecard-7e782.appspot.com",
  messagingSenderId: "458466668542"
};
firebase.initializeApp(config);

const storage = firebase.storage();
const db = firebase.firestore();
export {
  db, storage, firebase as default
}